export default "images/bnr.png";